import { BuyingStatus } from "../routes/Base/Plans/Details/types"

export function checkBuyingStatus(arg: string): arg is BuyingStatus {
  return arg !== undefined
}
